import { BlockDiagram } from '@cadstrom/cadstrom-shared';

import type { IColorSchemeSet } from '#components/cad-renderer/color-provider/cadstrom-color-provider.js';

/**
 * Merges the canonical block-diagram layer colours into a colour scheme set so
 * the semantic block-diagram layers (matched by name) theme correctly in both
 * light and dark mode while every other layer keeps the scheme's colours.
 *
 * @param scheme - The base colour scheme set.
 * @returns A new scheme set with block-diagram `colorsByName` merged in.
 */
export function mergeBlockDiagramColors(scheme: IColorSchemeSet): IColorSchemeSet {
	return {
		...scheme,
		colorSchemes: {
			light: {
				...scheme.colorSchemes.light,
				schLayers: {
					...scheme.colorSchemes.light.schLayers,
					colorsByName: {
						...scheme.colorSchemes.light.schLayers.colorsByName,
						...BlockDiagram.blockDiagramColorsByName('light'),
					},
				},
			},
			dark: {
				...scheme.colorSchemes.dark,
				schLayers: {
					...scheme.colorSchemes.dark.schLayers,
					colorsByName: {
						...scheme.colorSchemes.dark.schLayers.colorsByName,
						...BlockDiagram.blockDiagramColorsByName('dark'),
					},
				},
			},
		},
	};
}
